import '../components/checkoutForm/scripts/orderStatusPage.js';
import '../pages/checkout/scripts/index.js';
import '../pages/footer/scripts/index.js';
import '../components/cart/scripts/cart.js'
import '../components/cart/scripts/subscriptionGuard.js'
import '../components/pricingBox/scripts/index.js'
import '../components/slideInCart/scripts/index.js'
import '../components/checkoutOrderOverview/scripts/index.js'